/**
 * Sends a conversion event to Google Ads using gtag
 * @param conversionId - The Google Ads conversion ID
 * @param conversionLabel - The conversion label for the specific action
 * @param gclid - The Google Click ID (optional, will be passed if available)
 * @param value - The conversion value (optional)
 * @returns void
 */
export const sendGoogleAdsConversion = async (
  conversionId: string,
  conversionLabel: string,
  gclid?: string,
  value?: number,
): Promise<void> => {
  // Build the conversion event parameters
  const conversionData: Record<string, any> = {
    send_to: `${conversionId}/${conversionLabel}`,
  }

  // Add optional parameters if provided
  if (gclid) {
    conversionData.gclid = gclid
  }

  if (value !== undefined) {
    conversionData.value = value
    conversionData.currency = 'USD'
  }

  return new Promise((resolve) => {
    // Automatically resolve the promise if the conversion event is not sent within 2 seconds.
    const timeout = setTimeout(() => {
      resolve()
    }, 2000)

    // Resolve the promise when the conversion event is sent.
    const gtagCallback = () => {
      clearTimeout(timeout)
      resolve()
    }

    conversionData.event_callback = gtagCallback
    conversionData.event_timeout = 700

    // Send the conversion event
    window.gtag('event', 'conversion', conversionData)
  })
}
